import { useQuery } from '@tanstack/react-query';
import { getTeams } from '../api/teams';

export const useTeams = (queryString: string = '') =>
  useQuery({
    queryKey: ['teams', queryString],
    queryFn: () => getTeams(queryString),
  });
